"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../../http");
var Message_1 = require("../Message");
/**
 * A page view event is generated when a user "loads a page".  This could
 * be through a server side, or client side render.
 * in:
 *   page: the type of page being rendered
 *   storyId: the id of the story that this page is for
 *   partId: the id of the story part that this page is for, which can be undefined
 *   storyGroup: the story associated with the storyId
 *   storyPart: the story part associated with the storyId
 * out:
 *   this function returns a UUID for the event that was sent
 * side effects:
 *   this function caches some data from the models in window.ads, so that it can be
 *   easily read by the other functions later.
 */
var sendPageView = function (page, storyId, partId, storyGroup, storyPart) {
    var _a, _b, _c;
    window.ads = window.ads || {};
    // clear cached page data
    window.ads["story_id"] = undefined;
    window.ads["part_id"] = undefined;
    window.ads["is_brand_safe"] = undefined;
    window.ads["is_mature"] = undefined;
    window.ads["brand_safety_level"] = undefined;
    window.ads["brand_safety_source"] = undefined;
    var message = (0, Message_1.getCommonMessageFields)(page, storyId, partId, storyGroup, storyPart);
    // cache page data
    window.ads["page"] = page;
    window.ads["story_id"] = storyId;
    window.ads["part_id"] = partId;
    window.ads["page_view_id"] = message.id;
    window.ads["is_brand_safe"] = message.is_brand_safe;
    window.ads["is_mature"] = message.is_mature;
    window.ads["brand_safety_level"] = message.brand_safety_level;
    window.ads["brand_safety_source"] = message.brand_safety_source;
    // page_view specific fields
    message.user_is_premium = !!((_b = (_a = window.wattpad) === null || _a === void 0 ? void 0 : _a.currentUser) === null || _b === void 0 ? void 0 : _b.isPremium);
    message.story_tags =
        storyGroup && Array.isArray(storyGroup.tags)
            ? storyGroup.tags.join(" ")
            : "";
    message.is_paid_story = storyGroup ? storyGroup.isPaywalled : void 0;
    message.device_type = (_c = window === null || window === void 0 ? void 0 : window.wattpad) === null || _c === void 0 ? void 0 : _c.deviceType;
    (0, http_1.sendAthaEvent)("page_view", message);
    return message["id"];
};
exports.default = sendPageView;
